export enum ResponseTypeEnum {
    QUICK = "QUICK",
    AUTOMATIC = "AUTOMATIC"
}